/* eslint-env browser */
import { useNavigate } from 'react-router-dom';

export const navigateTo = (url, scienceDirectUrl) => () => {
  location.href = url === undefined ? scienceDirectUrl : url;
};

export const navigateBack = () => {
  const navigate = useNavigate();
  return () => navigate(-1);
};